import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from "prop-types";
const DateTimePicker = ({ label, selectedDate, onChange }) => {
  return (
    <div className="date-picker-component text-xs flex flex-col gap-1 mt-1">
      {/* <label className="text-black text-xs">{label}</label> */}
      <DatePicker
        selected={selectedDate}
        onChange={onChange}
        dateFormat="dd/MM/yyyy"
        timeFormat="HH:mm"
        className="p-2 !bg-transparent text-white border border-[#69CEA6] rounded-lg h-[40px]  w-[120px] "
        timeIntervals={15}
        style={{ width: "200px" }}
      />
    </div>
  );
};
DateTimePicker.propTypes = {
  label: PropTypes.any,
  selectedDate: PropTypes.any,
  onChange: PropTypes.func.isRequired
};
export default DateTimePicker;
